import { LineChart, Line, XAxis, Tooltip, ResponsiveContainer, BarChart, Bar, Cell } from "recharts";
import { Reveal } from "./Reveal";

const GROWTH = [
  { y: "'21", v: 18 },
  { y: "'22", v: 21 },
  { y: "'23", v: 24 },
  { y: "'24", v: 27 },
  { y: "'25", v: 30 },
  { y: "'26", v: 33 },
];

const YIELDS = [
  { n: "Thane", v: 7.2 },
  { n: "Andheri", v: 6.8 },
  { n: "Navi Mumbai", v: 6.5 },
  { n: "BKC", v: 6.1 },
  { n: "Lower Parel", v: 5.9 },
];

const tick = { fontSize: 10, fill: "#6B7686", letterSpacing: 1 };

export default function MarketSection() {
  return (
    <section id="market" data-testid="market-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">Market Signals</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-14">
            The case for <span className="italic text-primary">Thane</span>
          </h2>
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-6">
          <Reveal>
            <div data-testid="chart-growth" className="border border-border bg-white p-8 h-full">
              <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-2">
                Thane West commercial capital values
              </p>
              <p className="font-display font-semibold text-4xl md:text-5xl text-foreground mb-8">
                +83% <span className="text-lg text-muted-foreground font-light">5-yr trend*</span>
              </p>
              <div className="h-[220px]">
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={GROWTH} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
                    <XAxis dataKey="y" tick={tick} axisLine={false} tickLine={false} />
                    <Tooltip
                      formatter={(v) => [`₹${v}K / sq.ft`, "Capital value"]}
                      contentStyle={{ border: "1px solid #DEE3EA", borderRadius: 0, fontSize: 12 }}
                    />
                    <Line type="monotone" dataKey="v" stroke="#1B5FAD" strokeWidth={2.5} dot={{ r: 3, fill: "#1B5FAD" }} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div data-testid="chart-yield" className="border border-border bg-white p-8 h-full">
              <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-2">
                Indicative office rental yield vs MMR hubs
              </p>
              <p className="font-display font-semibold text-4xl md:text-5xl text-foreground mb-8">
                7.2% <span className="text-lg text-muted-foreground font-light">Thane yield*</span>
              </p>
              <div className="h-[220px]">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={YIELDS} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
                    <XAxis dataKey="n" tick={tick} axisLine={false} tickLine={false} interval={0} />
                    <Tooltip
                      formatter={(v) => [`${v}%`, "Yield"]}
                      contentStyle={{ border: "1px solid #DEE3EA", borderRadius: 0, fontSize: 12 }}
                    />
                    <Bar dataKey="v" radius={0}>
                      {YIELDS.map((d) => (
                        <Cell key={d.n} fill={d.n === "Thane" ? "#1B5FAD" : "#C9D6E6"} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </Reveal>
        </div>
        <p className="text-[11px] text-muted-foreground/70 mt-6">
          *Indicative market estimates for illustration. Verify independently before investing.
        </p>
      </div>
    </section>
  );
}
